import { initSection } from '../../core/shopify/init-section/index.js';
const NAMESPACE = '.js-fullscreen-hero';
initSection(NAMESPACE, (section)=>{
    const heroEl = section.querySelector('.FullscreenHero');
    const revealEffectEnabled = (heroEl === null || heroEl === void 0 ? void 0 : heroEl.dataset.revealEffect) === 'true';
    if (!revealEffectEnabled) return {
        unload: null
    };
    const block = section.querySelector('.js-fullscreen-hero-block');
    if (!block) return {
        unload: null
    };
    // Observe the block for initial entrance
    const blockObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                blockObserver.unobserve(entry.target);
                entry.target.classList.add('is-revealed');
            }
        });
    }, {
        threshold: [
            0,
            0.1
        ]
    });
    if (block) blockObserver.observe(block);
    return {
        unload: ()=>{
            blockObserver.disconnect();
        }
    };
});
